<template>
  <div>
    <Modal max-width="600" :show.sync="showAnonModal" :close="closeAnonModal">
      <template #title>
        <v-icon color="red" class="mr-2">mdi-alert-outline</v-icon>
        <span class="title">Avertissement</span>
      </template>
      <template #text>
        <h2 class="bold" v-html="message">
        </h2>
      </template>
      <v-spacer />
      <template #actions>
        <v-col class="d-flex justify-center">
          <v-btn v-if="allowSaving" width="292" class="mr-2 ml-2 mb-2" color="primary" @click="saveAndClose">
            <span class="d-none d-sm-inline-block">Enregistrer</span>
          </v-btn>
          <v-btn width="292" class="mr-2" color="secondary" @click="closeAnonModal">
            <span class="d-none d-sm-inline-block">Annuler</span>
          </v-btn>
        </v-col>
      </template>
    </Modal>
  </div>
</template>
<script>
import { EventBus } from '../../mixins';
import Modal from '@/components/Modal/Modal';

export default {
  components: { Modal },
  data () {
    return {
      showAnonModal: false,
      message: '',
      allowSaving: false
    };
  },
  mounted () {
    EventBus.$on('show-existing-emails-popup', (data) => {
      console.log('show-existing-emails-popup', data);
      this.showAnonModal = true;
      this.message = data.message;
      this.allowSaving = data.allowSaving;
    });
  },
  methods: {
    closeAnonModal () {
      this.showAnonModal = false;
    },
    saveAndClose(){
      this.showAnonModal = false;
      EventBus.$emit('save');
    }
  }
};
</script>
